import React from 'react'
import { Link } from 'react-router-dom';
import './TutorialHeader.scss';

export const TutorialHeader = () => {

    return (
        <div className="tutorial-panel">
            <h1>Tutorial</h1>

            <Link to='/take-photo'>
                Skip
            </Link>
            
        </div>
    )

}

export default TutorialHeader